import TableControlButton from './TableControlButton.component';

export default TableControlButton;
